//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "YoungManiaRatingScale",
  data() {
    return {
      form: {
        f1: "",
        f2: "",
        f3: "",
        f4: "",
        f5: "",
        f6: "",
        f7: "",
        f8: "",
        f9: "",
        f10: "",
        f11: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "无" },
        { value: "1", name: "有轻度或可能的心境高涨" },
        { value: "2", name: "主观感到有肯定的心境高涨；乐观；自信；愉悦" },
        { value: "3", name: "心境高涨；滑稽可笑" },
        { value: "4", name: "欣快；不适当的发笑；唱歌" },
      ],
      dataList2: [
        { value: "0", name: "无" },
        { value: "1", name: "主观感觉增加" },
        { value: "2", name: "活跃；手势增多" },
        { value: "3", name: "精力过剩；时有活动过多；不安宁（尚可安静下来）" },
        { value: "4", name: "运动性兴奋；持续活动过多（无法安静下来）" },
      ],
      dataList3: [
        { value: "0", name: "正常；没有增加" },
        { value: "1", name: "轻度或可能增加" },
        { value: "2", name: "主观感到有肯定有性兴趣增加" },
        { value: "3", name: "自发性的性兴趣；详细描述有关性的事" },
        { value: "4", name: "明显的性举动（针对患者、工作人员或检查者）" },
      ],
      dataList4: [
        { value: "0", name: "自述没有睡眠减少" },
        { value: "1", name: "睡眠比平时减少1小时或以下" },
        { value: "2", name: "睡眠比平时减少1小时以上" },
        { value: "3", name: "睡眠需求减少" },
        { value: "4", name: "否认需求睡眠" },
      ],
      dataList5: [
        { value: "0", name: "无" },
        { value: "2", name: "主观感到易激惹" },
        { value: "4", name: "检查中有时易激惹；近期在病房中有愤怒或恼怒发作" },
        { value: "6", name: "检查中经常不耐烦；自始至终回答简短、生硬" },
        { value: "8", name: "敌意；不合作；检查无法进行" },
      ],
      dataList6: [
        { value: "0", name: "无增多" },
        { value: "2", name: "感觉话多" },
        { value: "4", name: "时有语速语量增加或啰嗦" },
        { value: "6", name: "言语紧迫；语速语量持续增加；难以打断" },
        { value: "8", name: "急迫；无法打断，说个不停" },
      ],
      dataList7: [
        { value: "0", name: "无" },
        { value: "1", name: "赘述；轻度分散；思维敏捷" },
        { value: "2", name: "分散；缺乏思维目标；经常改变话题；思维加速" },
        { value: "3", name: "思维奔逸；离题；难以跟上其思路；音联；模仿言语" },
        { value: "4", name: "语无伦次；无法交流" },
      ],
      dataList8: [
        { value: "0", name: "正常" },
        { value: "2", name: "可疑的计划；新的兴趣" },
        { value: "4", name: "特殊的计划；超宗教观念" },
        { value: "6", name: "夸大或偏执观念；牵连观念" },
        { value: "8", name: "妄想；幻觉" },
      ],
      dataList9: [
       { value: "0", name: "无；合作" },
        { value: "2", name: "好讥讽；时常提高嗓门；戒备" },
        { value: "4", name: "要求过多；在病房中威胁" },
        { value: "6", name: "（检查中）威胁检查者；大声喊叫；检查困难" },
        { value: "8", name: "好斗；破坏性；无法检查" },
      ],
      dataList10: [
        { value: "0", name: "穿戴修饰得体" },
        { value: "1", name: "稍微仪态不整" },
        { value: "2", name: "修饰不佳；中度蓬乱；过分穿着" },
        { value: "3", name: "穿戴蓬乱；衣冠不整；过分地化妆" },
        { value: "4", name: "极度邋遢；奇装异服" },
      ],
      dataList11: [
        { value: "0", name: "有，承认有病；同意需要治疗" },
        { value: "1", name: "承认可能有病" },
        { value: "2", name: "承认有行为改变，但否认有病" },
        { value: "3", name: "承认可能有行为改变，但否认有病" },
        { value: "4", name: "否认有任何行为改变" },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = 0;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result += Number(form[key]);
      }
      console.log(result)
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Neuro/YoungManiaRatingScale.vue